import {Button} from "antd";

export default function FilterButton({filters, flipFilter, filterText, filterName}){
  return <Button
    className={`filter-button-${filterName}`}
    type={`${filters.has(filterName) ? 'primary' : ''}`}
    onClick={() => flipFilter(filterName)}
  >{filterText}</Button>
}
